import axios from 'axios';
import { getEventGraph, getEventSponsors } from 'src/api/graph';
import { getEventLogo } from 'src/utils/event_images';
import { parseEventPlanIndicators } from 'src/pages/plan/utils/indicators';

export async function getCompanies(eventId) {
	return await axios.get(`${process.env.RASAYESH_API_URL}/events/${eventId}/companies`, {
		headers: {
			'x-token': process.env.RASAYESH_API_TOKEN,
		},
	} as any);
}

export async function getFullEvent(eventId) {
	return await axios
		.get(`${process.env.RASAYESH_API_URL}/events/${eventId}`, {
			headers: {
				'x-token': process.env.RASAYESH_API_TOKEN,
			},
		} as any)
		.then(async (res) => {
			if (res.status === 200) {
				const event = res.data;
				event.border = null;
				event.floor = null;

				if (event.base_plan_border) {
					event.border = await fetch(`${process.env.RASAYESH_API_URL}/${event.base_plan_border}`).then(
						async (res) => await res.text()
					);
				}

				if (event.base_plan_floor) {
					event.floor = await fetch(`${process.env.RASAYESH_API_URL}/${event.base_plan_floor}`).then(
						async (res) => await res.text()
					);
				}

				if (event.base_plan_public_places) {
					event.public = await fetch(`${process.env.RASAYESH_API_URL}/${event.base_plan_public_places}`).then(
						async (res) => await res.text()
					);
				}

				if (event.base_plan_indicators) {
					const indicatorsSvg = await fetch(`${process.env.RASAYESH_API_URL}/${event.base_plan_indicators}`).then(
						async (res) => await res.text()
					);

					event.indicators = parseEventPlanIndicators(indicatorsSvg);
				}

				const eventGraph = (await getEventGraph(eventId))?.data;

				event.graph = {
					nodes: eventGraph?.nodes,
					links: eventGraph?.links,
				};
				event.booths = eventGraph?.booths;
				event.sponsors = (await getEventSponsors(eventId))?.data;

				if (!event.sponsors || event.sponsors.length === 0) {
					event.sponsors = [
						{
							id: event.id,
							logo: getEventLogo(event, 'fa'),
							title: event.short_title_fa,
							description: event.title_fa,
							is_event: true,
						},
					];
				}

				event.companies = (await getCompanies(eventId))?.data;
			}

			return res;
		});
}
